import { buildGetOptions, fetchWithErrorHandling } from "services/FetchUtils";
import { getRegistryURL } from "./Registry";
import { useAuthUser } from "react-auth-kit";

export interface IDockerProcessStatus {
  id: string;
  image: string;
  status: string;
  ports: string;
  names: string;
  createdAt: Date;
}

export interface IDockerEvent {
  status: string;
  from: string;
  scope: string;
  containerName: string;
  issuedAt: Date;
}

export interface IDockerStatus {
  processStatus: IDockerProcessStatus[];
  events: IDockerEvent[];
}

export const listDockerStatus = async (accessToken: string, environmentName: string) => {
  return fetchWithErrorHandling(
    `${getRegistryURL()}/v1/registry/environment/docker-events/${environmentName}`,
    buildGetOptions(accessToken),
  );
};

export const useDockerStatusService = () => {
  const authUser = useAuthUser();

  return {
    listDockerStatus: (environmentName: string) => listDockerStatus(authUser()?.access_token, environmentName),
  };
};
